export enum DeviceType {
  Unknown = 'Unknown',
  Ptu = 'Ptu',
  SpinHome = 'SpinHome',
  PtuCamera = 'PtuCamera',
  BatHome = 'BatHome',
  BatLeft = 'BatLeft',
  BatRight = 'BatRight',
}

export const DeviceTypeTitleDict: { [key in DeviceType]: string } = {
  Unknown: 'Unknown',
  Ptu: 'Tracking Unit',
  SpinHome: 'Camera',
  PtuCamera: 'Tracking Unit Camera',
  BatHome: 'Batter Home (BH) Camera',
  BatLeft: 'Batter Left (BL) Camera',
  BatRight: 'Batter Right (BR) Camera',
};

export const DeviceTypeNotificationDict: { [key in DeviceType]: string } = {
  Unknown: 'Unknown',
  Ptu: 'Tracking Unit',
  SpinHome: 'Camera',
  PtuCamera: 'Tracking Unit Camera',
  BatHome: 'Batter Home',
  BatLeft: 'Batter Left',
  BatRight: 'Batter Right',
};

export const DeviceTypeErrorDict: { [key in DeviceType]: string } = {
  Unknown: 'Unknown',
  Ptu: 'PTU',
  SpinHome: 'Spin',
  PtuCamera: 'Camera',
  BatHome: 'BH',
  BatLeft: 'BL',
  BatRight: 'BR',
};
